enum TemplateFittingEnum {
    None = 'none',
    External = 'external',
    Internal = 'internal',
    Both = 'both',
}

export default TemplateFittingEnum;
